var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"leaflet-card",attrs:{"rounded":"","to":{
    name: 'Leaflet',
    params: {
      leafletId: _vm.leaflet.slug ? _vm.leaflet.slug : _vm.leaflet?.leafletId.toString()
    }
  }}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-img',{attrs:{"alt":_vm.cover.alt,"eager":"","contain":"","src":_vm.cover.url}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }